export const weather = 'd0bf22baf76f56cfcc17acee03ecaf81';
export const tasty   = 'f751e49c55msh5ac3dd5854bf934p1fed7djsn0626d2cbe4ad';